export default __webpack_public_path__ + "static/media/1.5ab66b62.png";